module.exports = __webpack_public_path__ + "static/seeder-finance-9708481563cdf519a39ce2a78b6e61e8.png";